import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { EASE_LUXE } from "@/components/Reveal";

export default function ChooseUsername() {
  const { user, setUsername } = useAuth();
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user === false) navigate("/login");
    else if (user && user.username) navigate("/account");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await setUsername(value.trim());
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6 pt-24" data-testid="choose-username-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE_LUXE }} className="w-full max-w-md">
        <p className="mb-4 text-xs uppercase tracking-luxe text-velvet-gold">Almost there</p>
        <h1 className="font-heading text-5xl font-semibold leading-none tracking-tight text-white">Choose a username</h1>
        <p className="mt-6 text-sm font-light text-white/50">This is your login handle and your public display name on Vixera.</p>
        <form onSubmit={submit} className="mt-10 space-y-8">
          <input required minLength={3} maxLength={24} placeholder="e.g. midnight_muse" value={value} data-testid="username-input"
            onChange={(e) => setValue(e.target.value)}
            className="w-full border-b border-white/15 bg-transparent py-3 text-sm text-white focus:border-velvet-gold focus:outline-none" />
          {error && <p className="text-sm text-velvet-rose" data-testid="username-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="username-submit"
            className="w-full rounded-full bg-white py-4 text-xs uppercase tracking-luxe text-black transition-colors hover:bg-velvet-rose hover:text-white disabled:opacity-50">
            {loading ? "Saving…" : "Continue"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
